/* Accesso — l'unica schermata che funziona senza token, e l'unica che deve
 * esistere davvero già ora: senza sessione tutte le altre riceverebbero 401.
 *
 * Il messaggio d'errore sta sotto i campi e non sparisce da solo: chi sbaglia
 * la password fuori casa deve poterlo rileggere dopo aver riprovato. */

import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Avvertenza, Pulsante, Scheda } from '../componenti';
import { Campo } from '../componenti/Modulo';
import { Rotella } from '../componenti/Stati';
import { usaAccesso } from '../auth/ContestoAccesso';

interface StatoPosizione {
  da?: string;
}

export function Accesso() {
  const { accedi, autenticato, inCorso, errore } = usaAccesso();
  const naviga = useNavigate();
  const posizione = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const da = (posizione.state as StatoPosizione | null)?.da ?? '/';

  if (autenticato) return <Navigate to={da} replace />;

  async function invia(e: FormEvent) {
    e.preventDefault();
    const ok = await accedi(username, password);
    if (ok) naviga(da, { replace: true });
  }

  return (
    <div className="sb-accesso">
      <form className="sb-accesso__riquadro" onSubmit={invia}>
        <div className="sb-marchio" style={{ flexDirection: 'column', gap: 'var(--sb-s-4)' }}>
          {/* Il marchio su fondo scuro: il nastro superiore della S e' bianco e su fondo chiaro
              sparirebbe, ma qui il fondo e' sempre scuro. */}
          <img
            src="/brand/sembot-mark.png"
            alt=""
            width={52}
            height={52}
            style={{ display: 'block', width: 52, height: 52, borderRadius: 12 }}
          />
          <span className="sb-marchio__nome" style={{ fontSize: 'var(--sb-t-23)' }}>
            Sem<span className="sb-marchio__teal">Bot</span>
          </span>
          {/* Il teal compare solo qui, nel marchio: non è un colore d'accento. */}
          <span className="sb-etichetta" style={{ letterSpacing: '0.2em' }}>
            Build. Backtest. Trade.
          </span>
        </div>

        <Scheda>
          <div className="sb-colonna">
            <Campo
              etichetta="Nome utente"
              testuale
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <Campo
              etichetta="Password"
              testuale
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {errore && <Avvertenza livello="grave">{errore}</Avvertenza>}

            <Pulsante variante="primario" largo type="submit" disabled={inCorso}>
              {inCorso ? <Rotella dim={14} /> : null}
              {inCorso ? 'Accesso in corso…' : 'Entra'}
            </Pulsante>
          </div>
        </Scheda>

        {/* La frase che chi entra deve poter verificare ogni volta: è la
            promessa su cui si basa il fatto di digitare qui una password. */}
        <Avvertenza livello="nota">
          Le chiavi degli exchange non passano dal browser: restano sul backend e non sono mai
          leggibili da qui.
        </Avvertenza>

        <div className="sb-nota">
          La sessione scade da sola e non si rinnova: il backend non ha un token di rinnovo.
        </div>
      </form>
    </div>
  );
}
